export const TAB_TYPE = {
    POSITION_AUTHORITY: "position-authority", // 职位权限
    USER_AUTHORITY: "user-authority", // 用户权限
    LIB_DEVICE: "lib-device", // 库设备
    DEVICE: "device", // 设备
    COMPUTING_METHOD: "computing-method", // 计算方法
    CONSTITUTIVE_RELATION: "constitutive-relation", // 本构关系
    DRAW: "draw", // 绘图区
    ROOF_SLAB: "roof-slab", // 屋面板
    GUTTER: "gutter", // 天沟
    MONITOR_OBJECT: "monitor-object", // 监测对象
    MONITOR_PARAMETER: "monitor-parameter", // 监测参数
    WARNING: "warning", // 报警记录
    MONITOR_RELATION: "monitor-relation", // 传感器关联表
    MONITOR_THRESHOLD: "monitor-threshold", // 预警值
}